// extracted by mini-css-extract-plugin
export var backdropBlur = "_fb-0";
export var contentCard = "_fb-5";
export var frame = "_fb-2";
export var image = "_fb-4";
export var imagePane = "_fb-3";
export var modal = "_fb-1";